import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, { SubheaderLeft, SubheaderRight } from "../../../components/admin/layouts/Subheader/Subheader";
import Card from "../../../components/ui/Card";
import TablePartial from "./_partial/Table.partial";
import CompanyImg from "../../../assets/png/company.png";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import AddMachineModel from "../../../components/admin/home/addMachineModel";
import { useEffect, useState } from "react";
import { GetPagedAssets, postMachinesList } from "../../../services/FeaturedListings";
import { ApplicationId } from "../../../api/url";
import { logoutFun } from "../../../utils/helper";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled
import { getCompanyById } from "../../../services/companyService";
import getFirstLetter from "../../../utils/getFirstLetter";
import classNames from "classnames";
import useRoundedSize from "../../../hooks/useRoundedSize";
import { GetPictureByContext } from "../../../services/vizyBilityServices";

const AssetInfo = () => {
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const { roundedCustom } = useRoundedSize("rounded-xl");
  const [companyInfo, setCompanyInfo] = useState({});
  const [companyImg, setCompanyImg] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [pagination, setPagination] = useState({
    currectPage: 1,
    showRecords: 5,
    totalRecords: 10,
    pageCount: 1,
  });
  const [refresh, setRefresh] = useState(true);
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  useEffect(() => {
    GetCompanyInfo();
    GetCompanyImg();
  }, []);
  useEffect(() => {
    GetMachinesList();
  }, [pagination?.currectPage, pagination?.showRecords, refresh]);

  const GetCompanyInfo = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCompanyById(azureUserInfo?.CompanyId, header)
      .then((res) => {
        setCompanyInfo(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };
  const GetMachinesList = () => {
    setIsLoading(true);
    let payload = {
      Filter: { CompanyIds: [Number(azureUserInfo?.CompanyId)], IncludeAdvertisementInfo: true },
      IncludeCount: true,
      PageSize: pagination?.showRecords,
      PageNumber: pagination?.currectPage,
      Sort: "ChangeDate_desc",
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    GetPagedAssets(payload, header)
      .then((res) => {
        let showImgList = [];
        const xPagination = JSON.parse(res.headers.get("x-pagination"));
        res?.data?.map?.((item, index) => {
          showImgList[index] = {
            ...item,
            image: item?.primary_image?.url,
            caption: `<div  class="bg-[#000] responsive_text_field" style="background: rgba(0,0,0,0.5); width: 90%; margin: auto; text-align:right; padding:0px 10px ">
                        ${item?.year}&nbsp;&nbsp;&nbsp;${item?.model?.number}&nbsp;&nbsp;&nbsp;${item?.model?.manufacturer?.name} -  Click for Details
                      </div>`,
            assetAdvertisementId: item?.assetAdvertisementId,
            name: item?.primary_image?.name.replaceAll(" ", "-"),
          };
        });
        setPagination({
          ...pagination,
          totalRecords: xPagination?.TotalRecords,
          pageCount: xPagination?.TotalPages,
        });
        setMachineData(showImgList);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const handleResetPagination = () => {
    setPagination({
      ...pagination,
      currectPage: 1,
    });
    setRefresh(!refresh);
  };

  const setPageSize = (showRecords) => {
    setPagination({
      ...pagination,
      currectPage: 1,
      showRecords,
    });
  };

  const setPageIndex = (Index) => {
    setPagination({
      ...pagination,
      currectPage: Index,
    });
  };

  const GetCompanyImg = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Company&contextId=${azureUserInfo?.CompanyId}`;

    GetPictureByContext(query, header)
      .then((res) => {
        setCompanyImg(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Paving Market / Equipment Assets Info" currentPage="Equipment Assets" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>

      <PageWrapper name="Equipment Assets Info">
        <Subheader>
          <SubheaderLeft>
            <div className="flex items-center">
              <div className="mr-[10px]">
                {companyImg?.[0]?.url ? (
                  <img src={companyImg?.[0]?.url} alt="" className="h-12 w-12" />
                ) : (
                  <div
                    className={classNames(
                      "flex aspect-square h-12 w-12 items-center justify-center bg-blue-500/20 text-blue-500",
                      [`${roundedCustom(-2)}`]
                    )}
                  >
                    {companyInfo?.CompanyName && getFirstLetter(companyInfo?.CompanyName)}
                  </div>
                )}
              </div>
              <div>
                <div className="text-lg font-semibold">{companyInfo?.CompanyName}</div>
                <div className="text-sm text-zinc-500">
                  {companyInfo?.Address1} {companyInfo?.Address2}
                </div>
              </div>
            </div>
          </SubheaderLeft>
          {/* <SubheaderRight>sdas</SubheaderRight> */}
        </Subheader>
        <Container>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <Card className="h-full">
                <TablePartial
                  isLoading={isLoading}
                  machineData={machineData}
                  pagination={pagination}
                  setPageSize={setPageSize}
                  setPageIndex={setPageIndex}
                  handleResetPagination={handleResetPagination}
                />
              </Card>
            </div>
          </div>
        </Container>
      </PageWrapper>
    </>
  );
};
export default AssetInfo;
